import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { defaultServerUrls, environment } from '@paragon/environment-tools';
import { changeTracker, insertions, layoutModels } from '@paragon/layout-models';
import { logInData } from '@paragon/login-tools';
import { materialLists } from '@paragon/material-lists';
import { notifications } from '@paragon/notification-tools';
import { SyncClient } from '@paragon/sync-client';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { application } from './applicationSlice';
import { backlogGrid } from './backlogGridSlice';
import { batchesAndBundlesTab } from './batchesAndBundlesTabSlice';
import { batches } from './batchesSlice';
import { bundles } from './bundlesSlice';
import { componentDesignsWithInformationByAnalysisSetGuid } from './componentDesignsWithInformationByAnalysisSetGuidSlice';
import { historyGrid } from './historyGridSlice';
import { lineScheduleGrid } from './lineScheduleGridSlice';
import { lines } from './linesSlice';
import { popup } from './popupSlice';
import { productionComponentInstances } from './productionComponentInstancesSlice';
import { productionGroups } from './productionGroupsSlice';
import { productionOutputPresets } from './productionOutputPresetsSlice';
import { scheduleGrid } from './scheduleGridSlice';
import { scheduleGroups } from './scheduleGroupsSlice';
import { scheduleLineGroups } from './scheduleLineGroupsSlice';
import { stations } from './stationsSlice';
import { trailers } from './trailersSlice';
import { truckDrivers } from './truckDriversSlice';
import { truckloadGrid } from './truckloadGridSlice';
import { truckloads } from './truckloadsSlice';

const rootReducer = combineReducers({
  application,
  backlogGrid,
  batchesAndBundlesTab,
  batches,
  bundles,
  componentDesignsWithInformationByAnalysisSetGuid,
  historyGrid,
  lines,
  productionComponentInstances,
  productionGroups,
  productionOutputPresets,
  lineScheduleGrid,
  scheduleGrid,
  scheduleGroups,
  scheduleLineGroups,
  stations,
  trailers,
  truckDrivers,
  truckloadGrid,
  truckloads,

  spinnerMessages,
  logInData,
  environment,
  notifications,
  popup,
  theme,
  changeTracker,
  insertions,
  layoutModels,
  materialLists,
});

export const syncClient = new SyncClient({
  serverUrl: defaultServerUrls[process.env.APP_ENV!].synchronizationServerUrl,
});
syncClient.on('error', (event: any) => {
  console.error('sync error', event);
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(syncClient.state.middleware),
  devTools: false,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
